import type { LoaderParams } from "~/components/abstracts/Image/loader"

export const HOSTNAME = "a.storyblok.com"

export default function imageLoader({ src, width, quality }: LoaderParams) {
  return `${src}/m/${width}x0/filters:quality(${quality || 80})`
}
